import { render, staticRenderFns } from "./StepsZoom.vue?vue&type=template&id=2da529d0&scoped=true&"
import script from "./StepsZoom.vue?vue&type=script&lang=js&"
export * from "./StepsZoom.vue?vue&type=script&lang=js&"
import style0 from "./StepsZoom.vue?vue&type=style&index=0&id=2da529d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da529d0",
  null
  
)

export default component.exports